import { PayMethod } from '@/enums'

export const formatCurrency = (amount: number | string, decimalPlaces: number = 2): string => {
  return Number(amount).toLocaleString(undefined, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  })
}

/** 收款账号脱敏，与产品展示一致：银行卡 ***尾4、支付宝 首1+****+尾4、微信 首1+****+尾2、数币 ****+尾4 */
export function maskReceiveAccount(method: string, raw: string | undefined): string {
  const s = (raw ?? '').replace(/\s+/g, '')
  if (!s) return '****'

  switch (method) {
    // case PayMethod.BANKCARD: {
    //   const digits = s.replace(/\D/g, '')
    //   if (digits.length >= 4) return `***${digits.slice(-4)}`
    //   if (digits.length > 0) return `***${digits}`
    //   return '*******'
    // }
    // case PayMethod.ALIPAY: {
    //   if (s.length >= 5) return `${s[0]}****${s.slice(-4)}`
    //   if (s.length >= 2) return `${s[0]}****${s.slice(-1)}`
    //   return '****'
    // }
    // case PayMethod.WEPAY: {
    //   if (s.length >= 3) return `${s[0]}****${s.slice(-2)}`
    //   return `****${s.slice(-2) || '*'}`
    // }
    // case PayMethod.ECNY: {
    //   const digits = s.replace(/\D/g, '')
    //   const tail = digits.length >= 4 ? digits.slice(-4) : digits || s.slice(-4)
    //   return `****${tail || '****'}`
    // }
    default:
      return `****${s.slice(-4) || '****'}`
  }
}

/**
 * 去除 HTML 标签并解码常见实体，得到纯文本
 * 适用于跑马灯、列表摘要等只展示纯文本的场景
 */
export function stripHtml(html: string | null | undefined): string {
  if (html == null || html === '') return ''

  const text = String(html)
    // 块级/换行类标签先转空格，避免粘连
    .replace(/<\/?(?:br|p|div|li|tr|h[1-6])[^>]*>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/&amp;/gi, '&')
    .replace(/\s+/g, ' ')
    .trim()

  return text
}
